<template>
  <div>
    <div class="help_hotspot">
      <div class="left_help">
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot1 = !spot1">直播班讲义查询操作</a>
          </p>
          <p class="infor_spot" v-if="spot1">
            一、使用学而思网校app查询:
            <br />
            1.登录学而思网校APP
            <br />
            2.进入“学习中心”
            <br />
            3.点击“查看物流信息”查看运单状态
            <br />
            二、使用学而思网校官网查询:
            <br />
            1.登录学而思网校官网
            <br />
            2.点击右上方学习中心
            <br />
            3.查看讲义邮寄进度
            <br />
            4.点击“物流查询”跟踪运单状态
            <br />

            三、微信公众号查询:
            <br />
            1.微信公众号搜索“学而思网校官方服务号”
            <br />
            2.关注“学而思网校官方服务号”
            <br />
            3.登录绑定网校账户
            <br />
            4.绑定后进入，点击“我的订单”
            <br />
          </p>
        </div>
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot2 = !spot2">退换课、退费制度</a>
          </p>
          <p class="infor_spot" v-if="spot2">
            学而思网校退换课、退费制度
            <br />
            【直播班】
            <br />
            1、直播班在课程开课前可随时进行退课、课程调换；开课后进行调换，优惠差额需自行补齐。
            <br />
            2、直播场次大于等于五讲的课程，第一讲不满意可以全额退款，超过1讲可按照课程开课进度进行退款；
            直播场次小于五讲的课程，按照课程开课进度进行退款；如只是进行了第一讲，申请退课时，会扣除已经进行的直播费用
            <br />
            举例：
            <br />
            例如如果课程已开课2次，用户在第3次课开课前联系客服申请退课，会扣除2次课费用
            <br />
            如果课程已开课2次，用户在第4次课开课前联系客服申请退课，那么会扣除3次课费用
            <br />
            3、直播课具体的调班规则：
            <br />
            ①同班型、同版本、同授课老师的课程有不同的排期时间，用户可以进行自助操作调期。用户每个直播班有且仅有3次自助调期的机会，超过3次如再想调期需联系客服中心处理；
            <br />
            ②在进行调期时，会将用户优先分配原班的辅导老师，如果原班的辅导老师已满额，会给用户随机分配辅导老师；
            <br />
            ③如果用户所报名的直播课程所有讲均已经结束，将不能再进行调期；
            <br />
            ④如用户调课涉及到换老师、换班型、换版本时，均需要退课重买，且之前的学习记录不会保存，再次购买时辅导老师也会面临调整。
            <br />
            4、在购课时使用代金卡的，开课前，如需调换课，可联系客服中心重新领取一张代金卡作为换课使用；
            <br />
            5、如果用户下单超过5次，前台将不可购买；可联系客服中心进行内部下单操作购买；
            <br />
            6、网校推出自助退课的功能，钱会放在您的网校余额中，余额可以在购买其他的课程中使用。
            <br />
            使用APP操作路径：打开学而思网校APP-学习-点击课程名称-右上角+号-退课。
            <br />
            使用学而思网校网页操作路径：使用电脑登陆用户名-学习中心-更多服务-退课。
            <br />
            温馨提示：退课后直播回放、课后作业等都无法再看到，退课后课程无法恢复！如课程已停售或名额已满，将无法再进行购买；如购买课程时有使用代金卡，退课后代金卡失效，无法再次使用！
            <br />
            【录播班】
            <br />
            一、调换课基本原则：
            <br />
            1、退课：购买学而思网校课程后不超过7天，课程学习不超过2讲可申请退课或退费。
            <br />
            2、调换课：购买学而思网校课程后不超过7天，课程学习不超过2讲可申请调换课，但每个课程只有一次调换课机会，且如所调课程有差额需家长进行补齐。
            <br />
            3、课程升级：需调换课程与被调换课程（课程为在学习未过期状态）为包含关系时，用户需先补足课程间的差价，将课程进行调换，此为升级课程，升级后的课程不可再进行任何调退。
            <br />
            4、符合调、退课规则的同时，如该课程所附带的直播辅导的参与次数大于课程本身已学讲数时，课程会按照直播参与次数扣除已学金额，直播参与几次即为几讲。
            <br />
            说明：一个课程只能选择以上四项中的一种进行操作，且不论退课、调换课或是课程升级，仅有一次操作机会！
            <br />
            二、注意事项：
            <br />
            1、需按照原有课程顺序听课，如跳挑听课共计2讲，将不可进行全额退课或退费、调转。
            <br />
            2、微课程购买后不可进行任何调退。
            <br />
            3、促销课程不可调退课。
            <br />
            4、过期课程无法进行任何操作。
            <br />
            5、专题课程购买后不可退课。
            <br />
            使用学习卡购买课程的用户需要提供当时充值的准确学习卡号码，以便完成退费操作。
            <br />
            三、促销课程退换课规定：
            <br />
            1、 随促销课程所赠金币需退回，金币不足无法退换课。
            <br />
            2、 随促销课程所赠优惠券需作废，如优惠券已使用则无法退换课。
            <br />
            3、
            随促销课程所赠实物需在不影响二次赠送使用的前提下寄回客服部，且由此产生的邮寄费需用户承担，如发现赠品不符合条件，则无法退换课。
            <br />
            4、 随促销课程所赠课程需作废掉，才可退换课。
            <br />
            5、
            促销课程办理调转班（要调换成促销课程），需要参照“要调换的促销课程”的当日价格，如有差
            价需要补齐差价再进行调转班。比如A、B两个同等价格的课程5.10日前是8.5折，5.10日以后是8.8折，甲在5.10日之前购买了A课
            程，5.15日申请调换成B课程，需要补齐0.3折的差价方可办理调转班。
            <br />
            四、代金卡、课程卡购买课程退换课规定：
            <br />
            1、 使用代金卡购买课程，退换课程操作代金卡将失效。
            <br />
            2、 课程绑定卡课程不可进行课程调退。
            <br />
            温馨提示：
            <br />
            1、ios版移动客户端，通过学币购买的课程均不支持退课、退费操作。
            <br />
            2、反复恶意退课将不享受以上规则。
            <br />
          </p>
        </div>
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot3 = !spot3">视频加载中</a>
          </p>
          <p class="infor_spot" v-if="spot3">
            1、建议更换成火狐或者谷歌浏览器；
            <br />
            2、清理浏览器历史记录；
            <br />
            3、重启路由器：将路由器电源拔掉，断开5分钟以后，再重新接通电源尝试。
            <br />
            如果以上方法扔无法恢复正常，您可以提供给我们您的QQ号，由我们技术老师远程远程解决！
          </p>
        </div>
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot4 = !spot4">网校课程支付方式</a>
          </p>
          <p class="infor_spot" v-if="spot4">
            学而思网校的课程可以通过在线方式进行支付。目前支付的方式有：支付宝支付、微信支付、网上银行支付。支付成功以后，进入学习中心，即可看到已购买的课程。
            <br />
          </p>
        </div>
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot5 = !spot5">课程绑定卡激活流程</a>
          </p>
          <p class="infor_spot" v-if="spot5">
            您先登录学而思网校首页，注册用户名后，点击页面右上方的”卡激活“输入卡号与激活码激活领取课程，成功后点击”学习中心“进入课程学习即可。
            <br />
          </p>
        </div>
      </div>
      <div class="left_help right_lelp">
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot6 = !spot6">课程延期功能</a>
          </p>
          <p class="infor_spot" v-if="spot6">
            考虑到学员的特殊情况，当学员无法按时完成学习内容时，网校在课程有效期大于三天小于一个月时，提供了课程延期服务。在学习中心的课程右上角的“更多服务”中，会出现“延期”按钮，点击按钮可以将您的课程有效期延长45天。
            注意：每个课程只能延期一次；课程原本有效期就不到30天的课程，不提供课程延期服务。（系统赠送时间内不可延期）
            <br />
          </p>
        </div>
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot7 = !spot7">网校课程有效期</a>
          </p>
          <p class="infor_spot" v-if="spot7">
            课程有效期是指课程能正常学习的时段。用户在购买课程后，录播课程可以在有效期内无限次观看课程学习；
            直播课程只能在指定上课时段内参加直播课，但可以在有效期内无限次观看直播课程回放。
          </p>
        </div>

        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot8 = !spot8">直播视频卡顿怎么办</a>
          </p>
          <p class="infor_spot" v-if="spot8">
            重启路由器：拔掉电源，冷却几分钟,再接通电源。
            <br />
          </p>
        </div>
        <div class="list_infor">
          <p class="title_spot">
            <a href="javascript:void(0)" @click="spot9 = !spot9">购买直播课及学习流程</a>
          </p>
          <p class="infor_spot" v-if="spot9">
            <br />
            1.购买：注册网校帐号，从首页课程分类中选择对应的年级、科目，高端班型需要进行入学测试，通过后即可报名。
            <br />
            2.学习流程：支付成功后，需进入学习中心，即可看到课程，如果第一次登陆需要完善个人资料，填写后即可看到已购买课程。直播班需按照指定时间上课，在指定时间内，准备好提前收到的纸质版直播资料，建议提前5分钟进入直播间，待老师上课后即可参与学习。课后按照老师要求提交课后作业即可！
            <br />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spot1: false,
      spot2: false,
      spot3: false,
      spot4: false,
      spot5: false,
      spot6: false,
      spot7: false,
      spot8: false,
      spot9: false
    }
  }
}
</script>

<style lang="scss" scoped>
.help_hotspot {
  overflow: hidden;
  width: 845px;
  margin: 20px 0 20px 40px;
}
.help_hotspot .left_help {
  float: left;
  width: 430px;
  overflow: hidden;
  border-right: 1px solid #ededed;
}
.help_hotspot .left_help .list_infor {
  width: 100%;
}
.help_hotspot .left_help .list_infor .title_spot {
  line-height: 30px;
  padding-left: 12px;
  font-size: 14px;
  margin: 0 0 8.5px;
}
.help_hotspot .left_help .list_infor .title_spot a {
  color: #333;
}
.infor_spot {
  line-height: 180%;
  margin-left: 12px;
  color: #999;
}
.help_hotspot .right_lelp {
  float: right;
  width: 350px;
  padding-left: 40px;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// ./src/views/ArticleNav/components/hotSpot.vue